@if (CompanyVendor) {
  <div class="container-fluid p-0">
    <app-display-card>
      <dl class="cv-info">
        <!-- Identity & client -->
        <div class="cv-info__row">
          <dt>Vendor</dt>
          <dd>
            <span>{{ Vendor.legalName }}</span>
            <span class="cv-info__chip">ID {{ Vendor.id }}</span>
          </dd>
        </div>
        @if (Vendor.dba) {
          <div class="cv-info__row">
            <dt>Vendor DBA</dt>
            <dd>{{ Vendor.dba }}</dd>
          </div>
        }
        <div class="cv-info__row">
          <dt>Client</dt>
          <dd>
            <span>{{ Company.legalName }}</span>
            <span class="cv-info__chip">ID {{ Company.id }}</span>
          </dd>
        </div>

        <!-- Status & classification -->
        <div class="cv-info__row">
          <dt>Vendor status</dt>
          <dd>
            <span class="chip-host fw-semibold" appStatusStyleChanges>
              {{ CompanyVendor.viveStatus }}
            </span>
            @if (CompanyVendor.viveSubStatus) {
              <span class="text-secondary">
                — {{ CompanyVendor.viveSubStatus }}
              </span>
            }
            @if (CompanyVendor.isArchived) {
              <span class="cv-info__chip">Archived</span>
            }
          </dd>
        </div>
        @if (CompanyVendor.CompanyComplianceType) {
          <div class="cv-info__row">
            <dt>Compliance type</dt>
            <dd>{{ CompanyVendor.CompanyComplianceType.type }}</dd>
          </div>
        }
        @if (CompanyVendor.vendorRiskLevel) {
          <div class="cv-info__row">
            <dt>Tier</dt>
            <dd>{{ CompanyVendor.vendorRiskLevel }}</dd>
          </div>
        }

        <!-- Tax / contact -->
        <div class="cv-info__row">
          <dt>
            @if (CompanyVendor.country === 'US') {
              Tax ID
            }
            @if (CompanyVendor.country === 'CA') {
              GST/HST
            }
          </dt>
          <dd>
            @if (CompanyVendor.country === 'US') {
              @if (!Vendor.hasSSN) {
                <span>EIN: {{ Vendor.ein }}</span>
              }
              @if (maskedSSN) {
                <span>SSN: {{ maskedSSN }}</span>
              }
              @if (fullSSN) {
                <span>SSN: {{ fullSSN }}</span>
              }
              @if (!hasSSNAccess) {
                <span>SSN: ***-**-****</span>
              }
              @if (Vendor.hasSSN && hasSSNAccess && !maskedSSN && !fullSSN) {
                <button
                  type="button"
                  class="btn btn-ghost btn-sm p-0"
                  (click)="viewSSN()"
                >
                  View SSN
                </button>
              }
            }
            @if (CompanyVendor.country === 'CA') {
              {{ Vendor.bsn }}
            }
          </dd>
        </div>
        @if (Vendor.website) {
          <div class="cv-info__row">
            <dt>Website</dt>
            <dd>
              <a
                [href]="Vendor.website"
                target="_blank"
                rel="noopener noreferrer"
                class="cv-info__link"
              >
                {{ Vendor.website }}
              </a>
            </dd>
          </div>
        }
        <div class="cv-info__row">
          <dt>Email</dt>
          <dd>
            @if (ComplianceContact?.email) {
              <a
                href="mailto:{{ ComplianceContact!.email }}"
                class="email-link"
                >{{ ComplianceContact!.email }}</a
              >
            }
          </dd>
        </div>

        <!-- Addresses -->
        <div class="cv-info__row">
          <dt>Street address</dt>
          <dd>
            @if (StreetAddress) {
              {{ StreetAddress.address1 }}
              {{ StreetAddress.address2 }}
              {{ StreetAddress.city }},
              {{ StreetAddress.state }}
              {{ StreetAddress.zip }}
            } @else {
              —
            }
          </dd>
        </div>
        <div class="cv-info__row">
          <dt>Mailing address</dt>
          <dd>
            @if (MailingAddress) {
              {{ MailingAddress.address1 }}
              {{ MailingAddress.address2 }}
              {{ MailingAddress.city }},
              {{ MailingAddress.state }}
              {{ MailingAddress.zip }}
            } @else {
              —
            }
          </dd>
        </div>
        <div class="cv-info__row">
          <dt>Remit-to address</dt>
          <dd>
            @if (RemitToAddress) {
              {{ RemitToAddress.address1 }}
              {{ RemitToAddress.address2 }}
              {{ RemitToAddress.city }},
              {{ RemitToAddress.state }}
              {{ RemitToAddress.zip }}
            } @else {
              —
            }
          </dd>
        </div>

        <!-- Dates -->
        @if (!CompanyVendor.feeWaived && !CompanyVendor.feeWaivedDate) {
          <div class="cv-info__row">
            <dt>Last date paid</dt>
            <dd>
              {{ (CompanyVendor.lastPaymentDate | date: 'MM/dd/y') || '—' }}
            </dd>
          </div>
        }
        @if (CompanyVendor.feeWaived) {
          <div class="cv-info__row">
            <dt>Fee waived date</dt>
            <dd>
              {{
                (CompanyVendor.lastRenewalAnniversaryDate ||
                  CompanyVendor.feeWaivedDate | date: 'MM/dd/y') || '—'
              }}
            </dd>
          </div>
        }
        @if (CompanyVendor.needsFeeWaiveRenewal) {
          <div class="cv-info__row">
            <dt>Fee waived date</dt>
            <dd>
              {{
                (CompanyVendor.lastRenewalAnniversaryDate ||
                  CompanyVendor.lastFeeWaivedDate | date: 'MM/dd/y') || '—'
              }}
            </dd>
          </div>
        }
        @if (CompanyVendor.wasFeeWaived) {
          <div class="cv-info__row">
            <dt>Previously fee waived</dt>
            <dd>Yes</dd>
          </div>
        }
        <!-- VPDW-4240: two renewal clocks, two rows. They used to be one row
             labelled "Next renewal date", which was only ever the payment one —
             so a relationship suspended for "No Renewal - Vendor Info" showed a
             payment date months out and nothing explained the suspension. The
             scope chips carry the distinction that matters: payment renewal is
             per client relationship, information renewal is one date for the
             whole vendor. -->
        <div class="cv-info__row">
          <dt>Payment renewal</dt>
          <dd>
            <span class="cv-info__date">
              {{ (CompanyVendor.renewalDate | date: 'MM/dd/y') || '—' }}
            </span>
            <span class="cv-info__chip">This client</span>
          </dd>
        </div>
        <div class="cv-info__row">
          <dt>Information renewal</dt>
          <dd>
            <span class="cv-info__date">
              {{ (CompanyVendor.infoRenewalDueDate | date: 'MM/dd/y') || '—' }}
            </span>
            <span class="cv-info__chip">All clients</span>
            @if (infoRenewalIsAnchoredOnSignup) {
              <!-- The vendor has never completed an info renewal, so the date
                   above is derived from their signup date. It still drives
                   suspension, so it has to render — the chip stops a reviewer
                   reading it as a completed renewal. -->
              <span class="cv-info__chip">From signup date</span>
            }
            @if (infoRenewalChipLabel) {
              <span class="chip" [class]="infoRenewalChipClass">
                {{ infoRenewalChipLabel }}
              </span>
            }
          </dd>
        </div>

        <!-- Flag rows — render Yes/No as chips so insurance agents (and
             other reviewers) can spot the exempt / multi-client states
             at a glance. Yes uses the teal info chip to draw the eye;
             No uses the neutral chip so it's still visible as a flag
             without competing. We deliberately avoid success/warning/
             error chip families here — these are neutral booleans, not
             pass/fail statuses. Re-sign required is the exception: it is
             an outstanding obligation that withholds approval, so its Yes
             uses the warning chip, as the info-renewal chip above does. -->
        <div class="cv-info__row cv-info__row--flag">
          <dt>Workers' comp exempt</dt>
          <dd>
            @if (CompanyVendor.isWorkersCompExempt) {
              <span class="chip chip-info cv-info__flag cv-info__flag--yes">
                Yes — exempt
              </span>
            } @else {
              <span class="chip chip-neutral cv-info__flag">
                No — coverage required
              </span>
            }
          </dd>
        </div>
        <div class="cv-info__row cv-info__row--flag">
          <dt>Multi-client</dt>
          <dd>
            @if (CompanyVendor.hasMultipleClients) {
              <span class="chip chip-info cv-info__flag cv-info__flag--yes">
                Yes
              </span>
            } @else {
              <span class="chip chip-neutral cv-info__flag">No</span>
            }
          </dd>
        </div>

        <div class="cv-info__row cv-info__row--flag">
          <dt>Re-sign required</dt>
          <dd>
            @if (reSignRequired) {
              <span class="chip chip-warning cv-info__flag cv-info__flag--yes">
                Yes
              </span>
              @if (reSignRequiredDate) {
                <span class="cv-info__chip">
                  Flagged {{ reSignRequiredDate | date: 'MM/dd/y' }}
                </span>
              }
            } @else {
              <span class="chip chip-neutral cv-info__flag">No</span>
            }
          </dd>
        </div>
      </dl>

      <!-- Primary daily actions -->
      <div class="action-row justify-end cv-info__actions">
        <button
          type="button"
          class="btn btn-ghost"
          (click)="createComplianceNote()"
        >
          <i class="bi bi-journal-text me-1"></i>
          Create note
        </button>
        @if (!CompanyVendor.isArchived) {
          <button
            type="button"
            class="btn btn-outline"
            (click)="createTicket()"
          >
            <i class="bi bi-ticket me-1"></i>
            Create ticket
          </button>
        }
        @if (CurrentComplianceStep && AllowedSetStepStatusUserRoles()) {
          <button
            type="button"
            class="btn btn-primary"
            (click)="setStepStatus()"
          >
            <i class="bi bi-flag me-1"></i>
            Set step status
          </button>
        }
      </div>

      <!-- Canadian workers' comp review options (rare, ancillary) -->
      @if (CanadianWorkersCompensationTypes.length > 0) {
        <div class="action-row justify-end cv-info__secondary-actions">
          @for (
            CanadianWorkersCompensationType of CanadianWorkersCompensationTypes;
            track CanadianWorkersCompensationType
          ) {
            <button
              type="button"
              class="btn btn-outline btn-sm"
              (click)="displayCAWCModal(CanadianWorkersCompensationType)"
            >
              Review {{ CanadianWorkersCompensationType }}
            </button>
          }
        </div>
      }

      <!-- US workers' comp exempt controls (insurance step only) -->
      @if (
        CompanyVendor.country === 'US' && CurrentComplianceStep === 'Insurance'
      ) {
        <div class="action-row justify-end cv-info__secondary-actions">
          <button
            type="button"
            class="btn btn-outline btn-sm"
            (click)="updateWorkersCompExempt()"
          >
            {{ CompanyVendor.isWorkersCompExempt ? 'Unset' : 'Set' }}
            workers' comp exempt
          </button>
          @if (CompanyVendor.isWorkersCompExempt) {
            <button
              type="button"
              class="btn btn-outline btn-sm"
              (click)="setWorkersCompExemptValidity(true)"
            >
              WC exempt — pass
            </button>
            <button
              type="button"
              class="btn btn-outline btn-sm"
              (click)="setWorkersCompExemptValidity(false)"
            >
              WC exempt — fail
            </button>
          }
        </div>
      }
    </app-display-card>
  </div>
}
